import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3892a640")

_pushScopeId("data-v-3892a640")
const _hoisted_1 = { class: "world" }
const _hoisted_2 = { class: "swiper-wrap" }
const _hoisted_3 = { class: "swiper-container swiper-container-world" }
const _hoisted_4 = { class: "swiper-wrapper" }
const _hoisted_5 = { class: "juanzhou" }
const _hoisted_6 = { class: "text-wrap" }
const _hoisted_7 = { class: "text-title" }
const _hoisted_8 = { class: "text-desc" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "swiper-button-prev" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "swiper-button-next" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.swiperData, (item) => {
            return (_openBlock(), _createBlock("div", {
              class: "swiper-slide",
              key: item.id
            }, [
              _createVNode("div", _hoisted_5, [
                _createVNode("img", {
                  src: item.img,
                  class: "juanzhou-img",
                  alt: ""
                }, null, 8, ["src"])
              ]),
              _createVNode("div", _hoisted_6, [
                _createVNode("p", _hoisted_7, _toDisplayString(item.textTitle), 1),
                _createVNode("p", _hoisted_8, _toDisplayString(item.textDesc), 1)
              ])
            ]))
          }), 128)),
          _hoisted_9,
          _hoisted_10
        ])
      ])
    ])
  ]))
})